import { MAP_COORDINATE_SEARCH_CAPABILITY } from '@ooh/contracts';
import { useContextQuery } from '../../../hooks/use-context-query';

/**
 * Returns true only when the map coordinate-search feature flag is explicitly
 * enabled for the current user.
 *
 * FAIL-CLOSED: unlike the fail-open `useHasPermission`, this returns false while
 * the me-context is still loading and false whenever the capability is absent.
 * This guarantees the flaky coordinate search stays hidden in production unless
 * the `map-coordinate-search` flag row exists and is enabled.
 */
export function useMapCoordinateSearchEnabled(): boolean {
  const { data } = useContextQuery();
  return data?.capabilities.includes(MAP_COORDINATE_SEARCH_CAPABILITY) === true;
}
